<template>
  <div id="employee-detail">
    <CRow>
      <CCol :md="{ size: 8, offset: 2 }" class="employees-form">
        <div class="text-center">
          <h4 class="title-header">
            {{ $t("label.label_remote_infomation") }}
          </h4>
        </div>
        <div class="text-content">
          <label>{{ $t("employee.label_employee_code") }}</label>
          <div class="show-text">{{ remoteRequest.employee_id }}</div>
        </div>

        <div class="text-content">
          <label>{{ $t("employee.label_employee_name") }}</label>
          <div class="show-text">
            {{ remoteRequest.employee ? remoteRequest.employee.name : "" }}
          </div>
        </div>

        <div class="text-content">
          <label>{{ $t("employee.label_employee_position") }}</label>
          <div class="show-text">
            {{
              remoteRequest.employee
                ? objectNotNull(remoteRequest.employee.position)
                  ? remoteRequest.employee.position.name
                  : ""
                : ""
            }}
          </div>
        </div>

        <div class="text-content">
          <label>{{ $t("employee.label_employee_division") }}</label>
          <div class="show-text">
            {{
              remoteRequest.employee
                ? objectNotNull(remoteRequest.employee.department)
                  ? remoteRequest.employee.department.name
                  : ""
                : ""
            }}
          </div>
        </div>
        <div class="text-content">
          <label>{{ $t("employee.label_employee_date_start") }}</label>
          <div class="show-text">{{ remoteRequest.start_date }}</div>
        </div>

        <div class="text-content">
          <label>{{ $t("employee.label_employee_date_end") }}</label>
          <div class="show-text">{{ remoteRequest.end_date }}</div>
        </div>

        <div class="text-content">
          <label>{{ $t("commons.label_reason") }}</label>
          <div class="show-text">{{ remoteRequest.note }}</div>
        </div>

        <div class="text-content">
          <label>{{ $t("commons.label_status") }}</label>
          <div class="show-text">
            {{
              $t(
                `commons.label_status_remote_request_${remoteRequest.status}`
              )
            }}
          </div>
        </div>
      </CCol>
    </CRow>
    <CRow>
      <CCol md="8" sm="12" class="employees-form approval-ot">
        <div class="text-label">
          <div class="text-center">
            <h4 class="title-header">
              {{ $t("remote.information_approval_ot") }}
            </h4>
          </div>
        </div>
        <div class="text-label-content">
          <div class="table-responsive table-employee-note">
            <table class="table">
              <thead>
                <tr>
                  <th class="index">#</th>
                  <th class="text-center create-by">
                    {{ $t("remote.employee_approval") }}
                  </th>
                  <th class="text-center create-at">
                    {{ $t("remote.employee_approval_status") }}
                  </th>
                  <th class="text-center">
                    {{ $t("remote.employee_approval_note") }}
                  </th>
                  <th class="text-center">
                    {{ $t("remote.employee_approval_time") }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in listEmployeeIdApproval"
                  :key="index"
                >
                  <th scope="row index">{{ index + 1 }}</th>
                  <td>{{ item.employees.name }}</td>
                  <td class="text-center create-at">
                    {{ $t(`remote.employee_approval_${item.status}`) }}
                  </td>
                  <td class="text-center comment">{{ item.comment }}</td>
                  <td class="text-center">
                    {{ formatDateRemote(item.updated_at) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </CCol>
    </CRow>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";

export default {
  name: "Detail",
  metaInfo() {
    return {
      title: this.$t("page_title.page_remote_request_detail"),
      titleTemplate: "%s | " + this.$t("page_title.head_title")
    };
  },
  data() {
    return {
      employeeIdApproval1: "",
      employeeIdApproval2: "",
      listEmployeeIdApproval: []
    };
  },

  async created() {
    await this.showRemoteRequest();
    for (let key in this.remoteRequest.remote_request_approve) {
      this.listEmployeeIdApproval.push(
        this.remoteRequest.remote_request_approve[key]
      );
    }
  },

  computed: {
    ...mapGetters({
      remoteRequest: "remote-request/remoteRequest"
    })
  },

  methods: {
    ...mapActions("remote-request", ["detailRemoteRequest"]),

    async showRemoteRequest() {
      let remoteRequestId = this.$route.params.id;
      await this.detailRemoteRequest(remoteRequestId);
    },

    objectNotNull(obj) {
      if (obj) {
        return Object.keys(obj).length !== 0;
      }
    },

    formatDateRemote(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY HH:mm:ss");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#employee-detail {
  padding: 20px 100px;

  .note-ot {
    text-align: left;
    p.note {
      font-weight: 700;
      color: #ff1a1a;
    }

    label {
      font-weight: 600;
    }
    margin: 20px 0px;
  }

  .title-header {
    border-bottom: 2px solid #ea8910;
    padding-bottom: 15px;
    text-transform: uppercase;
    font-weight: 600;
    font-size: 16px;
  }

  .employees-form {
    padding: 0 50px;
    margin-bottom: 30px;

    .text-label h4 {
      color: #333;
      font-weight: 600;
      font-size: 20px;
      margin-bottom: 30px;

      .icon-text-label {
        margin-left: 8px;
      }
    }

    .text-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;

      .image {
        width: 70%;
      }

      label {
        width: 30%;
        color: #333;
        font-size: 13px;
        font-weight: 600;
      }
    }

    .show-text {
      border: 1px solid #fff;
      background-color: #fff;
      border: 1px solid #ccc;
      width: 70%;
      padding: 0 10px;
      height: 25px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .text-area {
      height: 60px;
    }

    .required {
      color: #dc1313;
      font-size: 13px;
    }
  }

  #toggle-btn {
    height: 37px;
  }

  .employees-form.approval-ot {
    margin: auto;

    .table-employee-note {
      background-color: white;
      margin-top: 20px;

      th {
        font-size: 15px;
      }

      td {
        color: #3c4b64;
      }

      td.comment {
        max-width: 300px;
        word-wrap: break-word;
      }
    }
  }
}
@media only screen and (max-device-width: 767px) {
  #employee-detail,
  #employee-detail .employees-form {
    padding: 0.3rem;
    .text-content {
      display: block;
      label {
        width: 100%;
      }
      .show-text {
        width: 100%;
        border-radius: 3px;
      }
    }
  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  #employee-detail {
    padding: 20px 0;
    .employees-form {
      padding: 0;
    }
  }
}
</style>
